const getDefaultState = () => ({
  suppliers: {
    loading: false,
    error: false,
    items: [],
  },
  transits: {
    loading: false,
    error: false,
    items: [],
  },
  carriers: {
    loading: false,
    error: false,
    items: [],
  },
  transport: {
    loading: false,
    error: false,
    item: null,
  },
  siblingTransport: {
    loading: false,
    error: false,
    item: null,
  },
  contractUpload: {
    loading: false,
    error: false,
  },
  transportItineraries: {
    loading: false,
    error: false,
  },
  seatingSectionTypes: {
    loading: false,
    error: false,
    items: [],
  },
  consumableTypes: {
    loading: false,
    error: false,
    items: [],
  },
  upgradeTypes: {
    loading: false,
    error: false,
    items: [],
  },
  luggageTypes: {
    loading: false,
    error: false,
    items: [],
  },
  tripSeatings: {
    loading: false,
    error: false,
    items: [],
  },
  tripConsumables: {
    loading: false,
    error: false,
    items: [],
  },
  tripUpgrades: {
    loading: false,
    error: false,
    items: [],
  },
  transportLuggage: {
    loading: false,
    error: false,
    items: [],
  },
  contracts: {
    loading: false,
    error: false,
    items: [],
  },
  overview: {
    loading: false,
    error: false,
    items: [],
  },
  searchTransports: {
    loading: false,
    error: false,
    items: [],
  },
  searchTransportsPriceSetting: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/non-dynamic-transport/defaultState.js